import React from "react";
import { Link } from "react-router-dom";
import { courses } from "../../../redux/actions/courses";
import {
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button
} from "reactstrap";
import moment from "moment";
import { connect } from "react-redux";

class AuthorCourseRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      name: "",
      displayname: "",
      error: ""
    };
    this.deleteCourse = this.deleteCourse.bind(this);
    this.togglePublish = this.togglePublish.bind(this);
  }
  componentDidMount() {
    const { course } = this.props;
    
    this.setState({
      name: course && course.name,
      displayName: course && course.displayName
    });
  }

  updateName() {
    try {
      this.setState({
        name: "",
        displayName: "",
        addingCourse: false
      });
    } catch (err) {
      switch (err) {
        case "NAME_EXIST_ERROR":
          this.showError(
            "Course Name Already Exists",
            this.props.updatingCourseFailure
          );
          break;
        case "EMPTY_FIELD":
          this.showError(
            "Both fields are required",
            this.props.updatingCourseFailure
          );
          break;
        default:
          console.log(err);
      }
    }
  }

  handleUpdateName = ({ target }) => this.setState({ name: target.value });
  handleUpdateDisplayName = ({ target }) =>
    this.setState({ displayName: target.value });

  deleteCourse() {
    const { course } = this.props;
    this.props.deleteCourse(course.id);
    this.setState({ showModal: false });
  }
  togglePublish() {
    const { course } = this.props;
    this.props.toggleCourseStatus(course.id, course.published);
    this.setState({ showModal: false });
  }
  showModal(course, action) {
    let modalText = "";
    let desc = "";
    let modalAction;
    if (action === "delete") {
      modalText = `Attempting to delete ${course.name} (${
        course.displayName
      }). Are you sure you want to delete this course? This action cannot be reversed. All course data will be lost. (If you want to hide the course from users, click the "unpublish" icon.)`;
      desc = "Delete";
      modalAction = this.deleteCourse;
    } else if (action === "publish") {
      if (course.published) {
        modalText = `Please confirm that you would like to UNPUBLISH ${
          course.name
        } (${
          course.displayName
        }). Once unpublished, the course can no longer be licensed to users, and any user who has an existing license to the course will not be able to access it. Unpublishing does not delete course data.`;
        desc = "Unpublish";
        modalAction = this.togglePublish;
      } else {
        modalText = `Please confirm that you would like to publish ${
          course.name
        } (${
          course.displayName
        }). Once published, the course can be licensed to users, and will be accessible to licensed users.`;
        desc = "Publish";
        modalAction = this.togglePublish;
      }
    }
    this.setState({
      showModal: true,
      modalText,
      desc,
      selectedCourseName: course.name,
      courseId: course.id,
      modalAction
    });
  }

  getModal() {
    return (
      <Modal isOpen={this.state.showModal} className={"modal-success"}>
        <ModalHeader>{this.state.desc} Course</ModalHeader>
        <ModalBody>{this.state.modalText}</ModalBody>
        <ModalFooter>
          <Button onClick={() => this.state.modalAction()} color="secondary">
            {this.state.desc}
          </Button>
          <Button
            onClick={() => this.setState({ showModal: false })}
            color="secondary"
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  render() {
    const { course } = this.props;
    return (
      <React.Fragment>
        {course && (
          <tr
            className={`${
              this.props.courseStatus
                ? !course.published
                : course.published
                ? "published-row"
                : "not-published-row"
            }`}
          >
            <td onClick={() => this.showModal(course, "publish")}>
              {
                <i
                  className={`${course.published ? "" : "not-"}published-icon`}
                  style={{
                    color: "#00D9C1",
                    fontSize: "x-large"
                  }}
                />
              }
            </td>
            <td>
              <Input
                className="course-input"
                name="quantity"
                id={course.id}
                type="text"
                value={this.state.displayName}
                placeholder="Enter Course Display Name"
                form="addform"
                onChange={event => this.handleUpdateDisplayName(event)}
                onBlur={event => {
                  this.props.changeDisplayName(
                    course,
                    this.state.displayName,
                    this.setState.bind(this)
                  );
                }}
                disabled={!course.published}
              />
            </td>
            <td>
              <Input
                className="course-input"
                id={course.id}
                name="quantity"
                type="text"
                value={this.state.name}
                form="addform"
                onChange={event => this.handleUpdateName(event)}
                onBlur={event => {
                  this.props.changeName(
                    course,
                    this.state.name,
                    this.setState.bind(this)
                  );
                }}
                disabled={!course.published}
              />
            </td>
            <td>
              <Link
                to={`/author/course/${course.id}`}
                style={{
                  color: "unset",
                  textDecoration: "none"
                }}
                className={this.props.active ? "active-icon" : ""}
              >
                <i className={`edit-icon`} />
              </Link>
            </td>

            <td>{moment(course.lastModified).format("MM/DD/YYYY")}</td>
            <td>
              <i
                onClick={() => this.showModal(course, "delete")}
                className="delete-icon"
              />
            </td>
            {this.getModal()}
          </tr>
        )}
      </React.Fragment>
    );
  }
}

export default connect(
  null,
  courses
)(AuthorCourseRow);



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorCourseRow.js